import { LOCATION_CHANGE } from 'react-router-redux';

export const SET_TAB_ID = 'SET_TAB_ID';

// Reducer
export default function appInfoReducer(state = 0, action) {
  const { type, payload } = action;
  switch (type) {
    case LOCATION_CHANGE:
      return Number(sessionStorage.getItem('tabID'));
    case SET_TAB_ID:
      return payload;
    default:
      return state;
  }
}

export function setTabID(payload) {
  return { type: SET_TAB_ID, payload };
}



// WEBPACK FOOTER //
// ./src/redux/modules/tabID.js